import api from '../api';

export const getStylization = async () => {
  const url = `/visualNetAtend`;
  return await api.get(url);
};
